import React, { useEffect } from 'react';

const AdsenseAd = ({ adSlot, publisherId, adFormat = 'auto', responsive = 'true', style }) => {
  useEffect(() => {
    try {
      if (window.adsbygoogle) {
        // Check if the push is needed, some ad formats might not require it
        // or it might cause issues if called redundantly.
        // For auto ads or if the ad unit is designed to fill, it might be okay.
        window.adsbygoogle.push({});
      }
    } catch (e) {
      console.error("Adsense error pushing ad:", e);
    }
  }, [adSlot]); // Re-run if adSlot changes, though typically it won't for a specific placement

  if (!adSlot || !publisherId) {
    console.warn("AdsenseAd: adSlot or publisherId is missing.");
    return null; 
  }

  return (
    <div style={{ textAlign: 'center', margin: '10px 0', ...style }}>
      <ins className="adsbygoogle"
           style={{ display: 'block' }} // Default, can be overridden by props.style or specific ad needs
           data-ad-client={publisherId}
           data-ad-slot={adSlot}
           data-ad-format={adFormat}
           data-full-width-responsive={responsive}>
      </ins>
    </div>
  );
};

export default AdsenseAd; 